export default "__VITE_PUBLIC_ASSET__4fecf700__"